import { WorkflowConfig } from '@finxone-platform/shared/sys-config-types';
import { getV1_0_163ToV1_0_164 } from './mapping/version-upgrades/version-1-0-163-to-1-0-164';
import { getV1_0_164ToV1_0_165 } from './mapping/version-upgrades/version-1-0-164-to-1-0-165';
import { getV1_0_165ToV1_0_166 } from './mapping/version-upgrades/version-1-0-165-to-1-0-166';
import { getV1_0_167ToV1_0_168 } from './mapping/version-upgrades/version-1-0-167-to-1-0-168';
import { getV1_0_166ToV1_0_167 } from './mapping/version-upgrades/version-1-0-166-to-1-0-167';
import { getV1_0_168ToV1_0_169 } from './mapping/version-upgrades/version-1-0-168-to-1-0-169';
import { getV1_0_169ToV1_0_170 } from './mapping/version-upgrades/version-1-0-169-to-1-0-170';
import { getV1_0_170ToV1_0_171 } from './mapping/version-upgrades/version-1-0-170-to-1-0-171';
import { getV1_0_171ToV1_0_172 } from './mapping/version-upgrades/version-1-0-171-to-1-0-172';

export function getMigrationFunctions(workflowConfig: WorkflowConfig): Map<string | undefined, () => object> {
  // add to upgradeMappings as new versions are available
  // dont forget to bump the version in the workflow-constants.type.ts file as well
  return new Map<string | undefined, () => object>([
    ['v1.0.163', () => getV1_0_163ToV1_0_164(workflowConfig)],
    ['v1.0.164', () => getV1_0_164ToV1_0_165(workflowConfig)],
    ['v1.0.165', () => getV1_0_165ToV1_0_166(workflowConfig)],
    ['v1.0.166', () => getV1_0_166ToV1_0_167(workflowConfig)],
    ['v1.0.167', () => getV1_0_167ToV1_0_168(workflowConfig)],
    ['v1.0.168', () => getV1_0_168ToV1_0_169(workflowConfig)],
    ['v1.0.169', () => getV1_0_169ToV1_0_170(workflowConfig)],
    ['v1.0.170', () => getV1_0_170ToV1_0_171(workflowConfig)],
    ['v1.0.171', () => getV1_0_171ToV1_0_172(workflowConfig)],
    // ['v1.0.172', () => getV1_0_172ToV1_0_173(workflowConfig)], // migration to upgrade quick links to use page ids, not been enabled yet as a lot projects still have broken quick links - will need implementing on latest version bump when ready
  ]);
}

/* Gets the first migration version from the migration functions map */
export function getFirstMigrationVersion(workflowConfig: WorkflowConfig): string | undefined {
  const migrations = getMigrationFunctions(workflowConfig);
  const first = migrations.keys().next();
  return first.done ? undefined : first.value;
}
